<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/electronics/s156-AM/s156-AM.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">

                <div class="detail-banner-t2">15.6 AMOLED Automotive Center Information Display</div>
                <div class="detail-banner-desc">
                    AMOLED display, 2.5K high-resolution, equipped with ToE touch technology.
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">
                <div class="detail-text-box">
                    <div class="detail-title">Product Introduction</div>
                    <div class="detail-desc">
                        <div>
                            Tandem design, the brightness can reach to 1000nits.
                        </div>
                        <div>
                            99% DCI-P3 color gamut.
                        </div>
                        <div>
                            Real 10 bit high color depth.
                        </div>
                        <div>
                            Ultra thin OLED screen, the total thickness is only 5.5mm.
                        </div>
                        <div>
                            Low Blue Light (Hardware Solution) design for eye-care.
                        </div>
                    </div>
                </div>

                <div class="one-titile">
                    Core Configuration
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/electronics/s156-AM/s156-AM-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                Parameters
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">AMOLED</div>
                                    <div class="k">Panel Technology</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">ToE</div>
                                    <div class="k">Touch Solution</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">No Backlight</div>
                                    <div class="k">Backlight Technology</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">2560 x 1440</div>
                                    <div class="k">Resolution</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1000nits</div>
                                    <div class="k">Luminance</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">1,000,000 : 1</div>
                                    <div class="k">Contrast</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">99% DCI-P3</div>
                                    <div class="k">Color Gamut</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '15.6 AMOLED Automotive Center Information Display - FINEST Website',
    keywords: 'FINEST,Engine,Transmission,Electronics',
    description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
    outputPath: 'en/electronics/s156-AM.html'

};

import { createApp } from 'vue';
import App from './s156-AM.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./s156-AM.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
